

import { Options, Vue, prop } from 'vue-class-component';
import { CheckIssuePusatResolusi } from '@/domain/entities/PusatResolusiV2';

class Props {
  modelValue = prop<CheckIssuePusatResolusi>({
    default: () => new CheckIssuePusatResolusi(),
    type: Object
  });
}

@Options({
  emits: ["close"],
  components: { }
})

export default class PopupIssueInformation extends Vue.with(Props) {

  forceCloseDialog() {
    this.$emit("close");
  }

  get mapStatusTicket(): any {
    const status = this.modelValue.statusTicket;
    const statusLabel: any = () => {
      const obj = {
        NEW: this.$t('pusatResolusi.new'),
        WORKING: this.$t('pusatResolusi.inProcess2'),
        ESCALATED: this.$t('pusatResolusi.inEscalation'),
        "ON HOLD": this.$t('pusatResolusi.onHold'),
        SOLVED: this.$t('pusatResolusi.solved'),
        CLOSED: this.$t('pusatResolusi.closed')
      } as any
      return obj[status] ?? status
    }
    const style: any = () => {
      const obj = {
        NEW: "bg-blue-lp-200 text-blue-lp-300",
        WORKING: "bg-yellow-lp-200 text-yellow-lp-100",
        ESCALATED: "bg-purple-lp-100 text-purple-lp-800",
        "ON HOLD": "bg-gray-lp-200 text-gray-lp-300",
        SOLVED: "bg-green-lp-300 text-green-lp-400",
        CLOSED: "bg-chocolate-lp-200 text-chocolate-lp-100"
      } as any
      return obj[status] ?? "bg-gray-lp-200 text-gray-lp-300"
    }
    return {
      label: statusLabel(),
      style: style()
    }
  }

  get isClaimInformation() {
    const action = this.modelValue.action.toUpperCase()
    return action === "CLAIM";
  }
  
  get isCsInformation() {
    const action = this.modelValue.action.toUpperCase()
    return action === "CS";
  }
  
  get isEligibleCategory() {
    return this.modelValue.isEligibleCategory;
  }
}
